export const keyboardabc = [
  [
    { key: 'space', w: 90, h: 40, icon: 'space.svg' },
    { key: 'a', w: 60, h: 70, icon: false },
    { key: 'b', w: 60, h: 70, icon: false },
    { key: 'c', w: 60, h: 70, icon: false },
    { key: 'd', w: 60, h: 70, icon: false },
    { key: 'e', w: 60, h: 70, icon: false },
    { key: 'f', w: 60, h: 70, icon: false },
    { key: 'g', w: 60, h: 70, icon: false },
    { key: 'h', w: 60, h: 70, icon: false },
    { key: 'i', w: 60, h: 70, icon: false },
    { key: 'j', w: 60, h: 70, icon: false },
    { key: 'k', w: 60, h: 70, icon: false },
    { key: 'l', w: 60, h: 70, icon: false },
    { key: 'm', w: 60, h: 70, icon: false },
    { key: 'n', w: 60, h: 70, icon: false },
    { key: 'o', w: 60, h: 70, icon: false },
    { key: 'p', w: 60, h: 70, icon: false },
    { key: 'q', w: 60, h: 70, icon: false },
    { key: 'r', w: 60, h: 70, icon: false },
    { key: 's', w: 60, h: 70, icon: false },
    { key: 't', w: 60, h: 70, icon: false },
    { key: 'u', w: 60, h: 70, icon: false },
    { key: 'v', w: 60, h: 70, icon: false },
    { key: 'w', w: 60, h: 70, icon: false },
    { key: 'x', w: 60, h: 70, icon: false },
    { key: 'y', w: 60, h: 70, icon: false },
    { key: 'z', w: 60, h: 70, icon: false },
    { key: 'backspace', w: 46, h: 32, icon: 'back.svg' },
  ],
];

export const keyboardOptions = [
  { title: 'ABC' },
  { title: 'abc' },
  { title: '123' },
  { title: '#+-' },
];

export const keyboardSpecial = [
  [
    { key: 'space', w: 90, h: 40, icon: 'space.svg' },
    { key: '!', w: 60, h: 70, icon: false },
    { key: '@', w: 60, h: 70, icon: false },
    { key: '#', w: 60, h: 70, icon: false },
    { key: '$', w: 60, h: 70, icon: false },
    { key: '%', w: 60, h: 70, icon: false },
    { key: '^', w: 60, h: 70, icon: false },
    { key: '&', w: 60, h: 70, icon: false },
    { key: '*', w: 60, h: 70, icon: false },
    { key: '(', w: 60, h: 70, icon: false },
    { key: ')', w: 60, h: 70, icon: false },
    { key: '-', w: 60, h: 70, icon: false },
    { key: '_', w: 60, h: 70, icon: false },
    { key: '+', w: 60, h: 70, icon: false },
    { key: '=', w: 60, h: 70, icon: false },
    { key: '[', w: 60, h: 70, icon: false },
    { key: ']', w: 60, h: 70, icon: false },
    { key: '{', w: 60, h: 70, icon: false },
    { key: '}', w: 60, h: 70, icon: false },
    { key: '|', w: 60, h: 70, icon: false },
    { key: '\\', w: 60, h: 70, icon: false },
    { key: ':', w: 60, h: 70, icon: false },
    { key: ';', w: 60, h: 70, icon: false },
    { key: ',', w: 60, h: 70, icon: false },
    { key: '.', w: 60, h: 70, icon: false },
    { key: '/', w: 60, h: 70, icon: false },
    { key: '?', w: 60, h: 70, icon: false },
    { key: 'backspace', w: 46, h: 32, icon: 'back.svg' },
  ],
];

export const keyboardABC = [
  [
    { key: 'space', w: 90, h: 40, icon: 'space.svg' },
    { key: 'A', w: 60, h: 70, icon: false },
    { key: 'B', w: 60, h: 70, icon: false },
    { key: 'C', w: 60, h: 70, icon: false },
    { key: 'D', w: 60, h: 70, icon: false },
    { key: 'E', w: 60, h: 70, icon: false },
    { key: 'F', w: 60, h: 70, icon: false },
    { key: 'G', w: 60, h: 70, icon: false },
    { key: 'H', w: 60, h: 70, icon: false },
    { key: 'I', w: 60, h: 70, icon: false },
    { key: 'J', w: 60, h: 70, icon: false },
    { key: 'K', w: 60, h: 70, icon: false },
    { key: 'L', w: 60, h: 70, icon: false },
    { key: 'M', w: 60, h: 70, icon: false },
    { key: 'N', w: 60, h: 70, icon: false },
    { key: 'O', w: 60, h: 70, icon: false },
    { key: 'P', w: 60, h: 70, icon: false },
    { key: 'Q', w: 60, h: 70, icon: false },
    { key: 'R', w: 60, h: 70, icon: false },
    { key: 'S', w: 60, h: 70, icon: false },
    { key: 'T', w: 60, h: 70, icon: false },
    { key: 'U', w: 60, h: 70, icon: false },
    { key: 'V', w: 60, h: 70, icon: false },
    { key: 'W', w: 60, h: 70, icon: false },
    { key: 'X', w: 60, h: 70, icon: false },
    { key: 'Y', w: 60, h: 70, icon: false },
    { key: 'Z', w: 60, h: 70, icon: false },
    { key: 'backspace', w: 46, h: 32, icon: 'back.svg' },
  ],
];

export const keyboardNumbers = [
  [
    { key: 'space', w: 90, h: 40, icon: 'space.svg' },

    { key: '1', w: 60, h: 70, icon: false },
    { key: '2', w: 60, h: 70, icon: false },
    { key: '3', w: 60, h: 70, icon: false },
    { key: '4', w: 60, h: 70, icon: false },
    { key: '5', w: 60, h: 70, icon: false },
    { key: '6', w: 60, h: 70, icon: false },
    { key: '7', w: 60, h: 70, icon: false },
    { key: '8', w: 60, h: 70, icon: false },
    { key: '9', w: 60, h: 70, icon: false },
    { key: '0', w: 60, h: 70, icon: false },
    { key: 'backspace', w: 46, h: 32, icon: 'back.svg' },
  ],
];
